import React, { useEffect, useState, useRef } from "react";
import {
  Alert as MuiAlert,
  Box,
  Grid,
  DialogActions,
  Button,
  CircularProgress,
} from "@mui/material";
import { spacing } from "@mui/system";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, FormProvider } from "react-hook-form";
import ReplayIcon from "@mui/icons-material/Replay";
import { useDispatch } from "react-redux";
import CustomCheckBox from "../../../../components/CustomCheckBox";

import { useDialog } from "../../../../contexts/DialogContext";
import useUser from "../../../../hooks/useUser";
import CustomTextField from "../../../../components/CustomTextField";

import { showSuccessSnackbar, showErrorSnackbar } from "../../../../redux/slices/snackbar";

const Alert = styled(MuiAlert)(spacing);

const SuspendUser = (props) => {
  const dispatch = useDispatch();
  const { suspendUser, isRenewSubmitting, addAutoRenewal } = useUser();
  const { user, fetchData } = props;
  const currentPolicyPayload = {
    filters: [],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
    sortFields: [],
  };

  React.useEffect(() => {
    if (Object.keys(user).length !== 0) {
      console.log(user.isEnabledSuspend, "user.status");
      const initialValues = {
        radUserId: user.radUserId,
        isSuspended: user.status == "SUSPENDED" ? true : false,
      };
      reset(initialValues);
    }
  }, [user]);

  const methods = useForm({});
  const {
    reset,
    handleSubmit,
    watch,
    resetField,
    formState: { errors },
    control,
  } = methods;
  const { unSetDialog, openDialog } = useDialog();

  const onSubmit = async (data) => {
    try {
      const payload = {
        radUserId: user.radUserId,
        isSuspended: data.isSuspended,
      };

      await suspendUser(payload);

      if (data.isSuspended) {
        dispatch(showSuccessSnackbar("User Suspended successfully!"));
      } else {
        dispatch(showSuccessSnackbar("User Activated successfully!"));
      }

      fetchData();
      unSetDialog("suspend");
    } catch (ex) {
      dispatch(showErrorSnackbar(ex.message));
    }
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={12} className="row" pt={8}>
            <Grid item md={6}>
              <i>Do You want to Suspend the User</i>

              <CustomCheckBox
                label="Enable"
                name="isSuspended"
                type="checkbox"
                my={2}
                fullWidth
                errors={errors}
              />
            </Grid>
          </Grid>
          <DialogActions>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<ReplayIcon />}
              endIcon={isRenewSubmitting ? <CircularProgress size={24} /> : null}
              disabled={false}
            >
              Yes
            </Button>

            <Button variant="text" onClick={() => unSetDialog("suspend")} color="primary">
              No
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </React.Fragment>
  );
};
export default SuspendUser;
